export enum CountBehaviour {
  Disabled = 10,
  Enabled = 20,
}
